import { type ExamCourseType, type ExamCourseLanguage } from '@exam-center/graphql';

export const EXAM_COURSE_TYPE_TEXT: Record<ExamCourseType, string> = {
  MAIN: 'Main',
  MOCK: 'Mock',
};

export const EXAM_COURSE_LANGUAGE_TEXT: Record<ExamCourseLanguage, string> = {
  TH: 'Thai',
  EN: 'English',
};
